









import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import dayjs from 'dayjs'
import InputGroup from '@/mixins/form/inputGroup'
import { getAllDatesOfMonth } from '@/utils/datetime'
import { DateString } from '@/types/utils'

const TODAY = dayjs()
const START_OF_DATE = TODAY.subtract(120, 'year')

@Component({
  components: {
    SelectInput: () => import('@/components/common/inputs/SelectInput.vue')
  }
})
export default class BirthDateSelectInputGroup extends mixins(InputGroup) {
  @Prop(String) value!: string | null
  dayjs = dayjs

  inputYear: number | null = !this.value ? null : this.inputAsDayjs.year()
  inputMonth: number | null = !this.value ? null : this.inputAsDayjs.month() + 1
  inputDay: number | null = !this.value ? null : this.inputAsDayjs.date()

  get inputAsDayjs() {
    return this.value ? dayjs(this.value) : TODAY
  }

  get yearOptions() {
    const start = START_OF_DATE.year()
    const end = TODAY.year()
    return [...new Array(end - start + 1)].map((_, i) => start + i)
  }

  get monthOptions() {
    if (!this.inputYear) {
      return []
    }
    return this.generateMonthOptions(this.inputYear)
  }

  get dayOptions() {
    if (!this.inputYear || !this.inputMonth) {
      return []
    }
    return getAllDatesOfMonth(this.inputYear, this.inputMonth)
  }

  generateMonthOptions(selectedYear: number) {
    const thisYear = TODAY.year()
    const thisMonth = TODAY.month() + 1

    if (selectedYear === thisYear) {
      return [...new Array(thisMonth)].map((_, i) => i + 1)
    }

    return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
  }

  handleChangeYear(value: number | null) {
    if (value === null) {
      this.inputMonth = null
      this.inputDay = null
    } else if (
      this.inputMonth &&
      this.monthOptions.indexOf(this.inputMonth) === -1
    ) {
      this.inputMonth = this.monthOptions[0]
      this.inputDay = this.dayOptions[0]
    } else if (this.inputDay && this.dayOptions.indexOf(this.inputDay) === -1) {
      this.inputDay = this.dayOptions[0]
    }

    if (this.selectedDate !== this.value) {
      this.$emit('input', this.selectedDate)
    }
  }

  handleChangeMonth(value: number | null) {
    if (value === null) {
      this.inputDay = null
    } else if (this.inputDay && this.dayOptions.indexOf(this.inputDay) === -1) {
      this.inputDay = this.dayOptions[0]
    }

    if (this.selectedDate !== this.value) {
      this.$emit('input', this.selectedDate)
    }
  }

  handleChangeDay() {
    if (this.selectedDate !== this.value) {
      this.$emit('input', this.selectedDate)
    }
  }

  get selectedDate() {
    if (
      [this.inputYear, this.inputMonth, this.inputDay].some(
        input => input === null
      )
    ) {
      return null
    }
    return dayjs(
      new Date(
        this.inputYear as number,
        (this.inputMonth as number) - 1,
        this.inputDay as number
      )
    ).format('YYYY-MM-DD') as DateString
  }
}
